type RequestTracking = {
	// The request path with the query string removed.
	requestUrl: string;
	// The request path with numeric ids replaced by {id} to keep analytics cardinality low.
	requestUrlTemplate: string;
};

export const getRequestTracking = (url: string): RequestTracking => {
	const requestUrl = url.split('?')[0];
	const requestUrlTemplate = requestUrl.replace(/\/\d+(?=\/|$)/g, '/{id}');
	return { requestUrl, requestUrlTemplate };
};
